// extracted by mini-css-extract-plugin
export var contactButtonMail = "divisionInformation-module--contactButtonMail--1f0b4";
export var contactButtonPhone = "divisionInformation-module--contactButtonPhone--000a4";
export var content = "divisionInformation-module--content--aa4d1";
export var contentDetail = "divisionInformation-module--contentDetail--79c09";